import { useFormik } from "formik";
import Chip from "global/Chip/Chip";
import CustomPersonalizeForm from "global/CustomSwitchInput/CustomPersonalizeForm";
import { paginationType } from "global/Interfaces/Interfaces";
import SimpleButton from "global/SimpleButton/SimpleButton";
import { FC, useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { filterQuestionBank, setFilterQuestionBank } from "redux/survey/question-bank";
import { QuestionFilterElements } from "./filters";


interface OptionType {
  id: number | string;
  text: string;
}

interface QuestionBankSearchProps {

   options: {
    replyTypeSelect: OptionType[]; 
    questionTypeSelect: OptionType[];
    questionAssessmentMethodSelect: OptionType[];
  };
}


const QuestionBankSearch: FC<QuestionBankSearchProps> = ({options}) => {
  const [chipData, setChipData] = useState("");
  const { pageNumbers } = useSelector(
    (state: paginationType) => state.paginate
  );

 
  const [filterData, setFilterData] = useState({});
  const dispatch = useDispatch();


  const formik = useFormik({
    enableReinitialize: true,
    initialValues: {
      surveyType:null,
      questionType:null,
      replyType:null
    },
    onSubmit: async (values: any) => {
  
      setFilterData(values);

      setChipData({ ...values, hubId: undefined });
    },
  });

  const { values, handleSubmit, handleReset }: any = formik;

  useEffect(() => {
    const finalData = {
      ...values,
      surveyType: values.surveyType?.id,
      questionType:values.questionType?.id,
      replyType:values.replyType?.id,
    
    };
    dispatch(setFilterQuestionBank({ ...finalData }));
    dispatch(
      filterQuestionBank({
        ...finalData,
        pageSize: 10,
        pageNumber: pageNumbers,
      }) as any
    );
    return () => {
      // dispatch(clearCreditSettlement());
    };
  }, [filterData, pageNumbers, dispatch]);

  return (
    <>
   
      <form onSubmit={handleSubmit} className="searchForm ">
 
        {QuestionFilterElements.filter((item) => item.isMain).map(
          (item: any, index: number) => {
            return (
              <CustomPersonalizeForm
                key={index}
                element={item}
                formik={formik}
                selectOptions={{
                  ...options,
                }}
                // fetchInputOnchange={fetchInputOnchange}
              />
            );
          }
        )}
        <SimpleButton searchBtn />

    
      </form>
      {filterData && (
        <Chip
          filterData={chipData}
          formData={formik}
        
          
        />
      )}
    </>
  );
};

export default QuestionBankSearch;
